import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../models/userDetails';
import axios from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';

interface UserState {
  data: UserDetails | null;
  loading: boolean;
  error: string | null;
}

const initialState: UserState = {
  data: null,
  loading: false,
  error: null,
};


let notAccessible_response:any={
  "empId": null,
  "employeeDetailsDTO": null,
  "roleAccessMap": {},
  "requestDTO": null,
  "empAccessReqRaised": false,
  "employeeOrderAccess": false
} 

export const fetchUserData:any = createAsyncThunk(
  'user/checkAccessToMyOrder',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          //  'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`user/accessToMyOrder`,axiosConfig);
      console.log('user/accessToMyOrder',response);
      if (response.data.status!=="OK") {
        const errorData = await response.data.error
        return rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const userSlice:any = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState['data']>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchUserRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchUserSuccess: (state, action: PayloadAction<UserState['data']>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchUserFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const { setUser, fetchUserRequest, fetchUserSuccess, fetchUserFailure } = userSlice.actions;

export default userSlice.reducer;